<template>
  <div class="wrapper">
    <div class="full-area padded vertically-centered desktop-wrapper">
      <SensataSplash></SensataSplash>
    </div>
  </div>
</template>

<script>

export default {
  name: 'Home',

  transition: 'page',

  components: {
    SensataSplash: () => import('Components/base/SensataSplash')
  },

  data () {
    return {
      canForward: false
    }
  },

  computed: {
    pages () {
      return this.$store.state.site.pages
    },
    sensataShowSplash () {
      return process.env.VUE_APP_SHOW_SENSATA_SPLASH
    },
    sid () {
      return process.env.VUE_APP_DEFAULT_SID
    }
  },

  methods: {
    /*
     * If there's at least one page, redirect there automatically
     */
    pushSite () {
      if (!this.canForward) {
        return
      }
      if (this.pages && this.pages.length && this.canForward) {
        this.$router.push({ name: 'page', params: { alias: this.pages[0].fields.alias } })
        this.$router.push(`/p/${this.pages[0].fields.alias}`)
      } else {
        if (this.sid) {
          this.$router.push({ name: 'survey', params: { sid: this.sid, qid: 0 } })
        }
      }
    }
  },

  mounted () {
    var sensataSplashTimer = this.sensataShowSplash ? 2200 : 0

    setTimeout(() => {
      this.canForward = true
    }, sensataSplashTimer)

    this.pushSite()
  },
  watch: {
    'pages': function (newVal, oldVal) {
      if (newVal && newVal.length) {
        this.pushSite()
      }
    },
    'canForward': function (newVal, oldVal) {
      if (newVal) {
        this.pushSite()
      }
    }
  }
}
</script>

<style scoped lang="scss">
h1 {
  color: $color-emphasis;
}

.wrapper {
  background: white !important;
}
.desktop-wrapper {
  box-shadow: none;
}
</style>
